import _concat from "lodash/concat";
import _groupBy from "lodash/groupBy";
import _keyBy from "lodash/keyBy";
import _each from "lodash/each";
import _omit from "lodash/omit";

const treeToList = (tree, depth) => {
    let output = [];

    if (depth === undefined) {
        depth = 0;
    }

    tree.forEach((category) => {
        output.push({
            ...category,
            depth: depth,
        });
        if (category.children) {
            output = _concat(output, treeToList(category.children, depth + 1));
        }
    });

    return output;
};

function listToTree(list) {
    // add index to each category
    list = list.map((category, index) => {
        return { ...category, index };
    });

    var groupedByParents = _groupBy(list, "parent_id");
    var catsById = _keyBy(list, "id");

    // add children to each category
    _each(_omit(groupedByParents, null), function (children, parentId) {
        catsById[parentId].children = children;
    });

    return groupedByParents[null];
}

export const reorderCategories = (categories) => {
    if (categories.length === 0) return [];

    const tree = listToTree(categories);
    const list = treeToList(tree);

    return list;
};
